/**
 * Marketing Module - Promotions Page
 * 
 * Gestión de promociones y descuentos
 */
export default function Promotions() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <h1 className="text-3xl font-bold text-tf-text mb-6">Promociones</h1>
      <div className="bg-tf-bg-card shadow rounded-lg p-6">
        <p className="text-tf-text-muted">Gestión de promociones - En desarrollo</p>
      </div>
    </div>
  )
}













